// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-9-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.8771 11C16.1185 10.4663 16.2529 9.87386 16.2529 9.25C16.2529 6.90279 14.3501 5 12.0029 5C9.65572 5 7.75293 6.90279 7.75293 9.25C7.75293 11.5972 9.65572 13.5 12.0029 13.5C13.7263 13.5 15.2101 12.4743 15.8771 11ZM15.8771 11L11.0029 19.5H10.9999L15.8771 11Z","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers91Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-9-1',
    ref,
    icon: element,
  },
));

Numbers91Icon.displayName = 'Numbers91Icon';

export default Numbers91Icon;
